__turbopack_context__.v({
  "contact": "styles-module__SV5I_G__contact",
  "contactContainer": "styles-module__SV5I_G__contactContainer",
  "icon": "styles-module__SV5I_G__icon",
});
